import {
    CHARGE_LOADING,
    CHARGE_LOADED,
    CHARGE_CREATED,
    CHARGE_EDITED,
    CHARGE_DELETED,
    CHARGE_SEARCH,
    CHARGE_FAILED,
    MNOFEE_LOADING,
    MNOFEE_LOADED,
    MNOFEE_CREATED,
    MNOFEE_EDITED,
    MNOFEE_DELETED,
    MNOFEE_FAILED,
    LOGOUT,
} from '../types';

import {
    createPaginated,
    editPaginated,
    deletePaginated,
    editedUpdate,
    created,
    deleteFromState,
} from '../../helpers/reduxUtils';

const initialState = {
    mnofees: [],
    loading: false,
    allCharges: null,
    searchResults: null,
    success: false,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CHARGE_LOADING:
        case MNOFEE_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
            };
        case MNOFEE_DELETED:
            return {
                ...state,
                loading: false,
                mnofees: deleteFromState(state.mnofees, action.payload),
            };
        case MNOFEE_EDITED:
            return {
                ...state,
                loading: false,
                mnofees: editedUpdate(state.mnofees, action.payload),
            };
        case MNOFEE_CREATED:
            return {
                ...state,
                loading: false,
                mnofees: created(state.mnofees, action.payload),
            };
        case MNOFEE_LOADED:
            return {
                ...state,
                loading: false,
                mnofees: action.payload,
            };
        case CHARGE_LOADED:
            return {
                ...state,
                loading: false,
                allCharges: action.payload,
            };
        case CHARGE_CREATED:
            return {
                ...state,
                loading: false,
                success: true,
                allCharges: createPaginated(state.allCharges, action.payload),
            };
        case CHARGE_EDITED:
            return {
                ...state,
                loading: false,
                success: true,
                allCharges: editPaginated(state.allCharges, action.payload),
            };
        case CHARGE_DELETED:
            return {
                ...state,
                loading: false,
                success: true,
                allCharges: deletePaginated(state.allCharges, action.payload),
            };
        case CHARGE_SEARCH:
            return {
                ...state,
                loading: false,
                success: false,
                searchResults: action.payload,
            };
        case MNOFEE_FAILED:
        case CHARGE_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
            };
        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}